import FAQ from './models'

export default FAQ
